export { default as RestaurantSchedule } from './RestaurantSchedule'
